// Import any requires library
// import { apolloClient } from '@/setup/apollo-setup';

// Import any utility
// import { error, newItemSuccess, updateItemSuccess, deleteItemSuccess } from '@/utils/notification';

// Import defined GraphQL Query or Mutation

// import {
//   GET_SOMETHING,
//   GET_SOMETHINGS,
//   GET_SOMETHINGS_BYFILTER,
//   ADD_SOMETHING,
//   UPDATE_SOMETHING,
//   DELETE_SOMETHING
// } from '@/queries/modules/any-module';


// Get single data example

// export async function getSomething(context) {
//   context.commit('setProcessing', true);

//   try {
//     const result = await apolloClient
//       .query({
//         query: GET_SOMETHING,
//         // fetchPolicy: 'network-only'
//       });

//     const { data, errors } = await result;

//     if (errors) {

//       context.commit('setError', error(errors));
//       return null;

//     } else {

//       context.commit('setSomething', data.getSomething);
//       context.commit('setSuccess', null);
//       return data.getSomething;

//     }

//   } catch (e) {

//     context.commit('setError', error(e));
//     return null;

//   }
// }


// // Get data list example

// export async function getSomethings(context, payload) {
//   context.commit('setProcessing', true);

//   try {
//     const variables = payload;

//     const result = await apolloClient
//       .query({
//         query: GET_SOMETHINGS,
//         variables,
//         // fetchPolicy: 'network-only'
//       });

//     const { data, errors } = await result;

//     if (errors) {

//       context.commit('setError', error(errors));
//       return [];

//     } else {

//       context.commit('setSomethings', data.getSomethings);
//       context.commit('setSuccess', null);
//       return data.getSomethings;

//     }

//   } catch (e) {

//     context.commit('setError', error(e));
//     return [];

//   }
// }


// // Get data list by filter example

// export async function getSomethingsByFilter(context) {
//   context.commit('setProcessing', true);

//   try {
//     const variables = payload;

//     const result = await apolloClient
//       .query({
//         query: GET_SOMETHINGS_BYFILTER,
//         variables,
//         // fetchPolicy: 'network-only'
//       });

//     const { data, errors } = await result;

//     if (errors) {

//       context.commit('setError', error(errors));
//       return [];

//     } else {

//       context.commit('setSomethings', data.getSomethingsByFilter);
//       context.commit('setSuccess', null);
//       return data.getSomethingsByFilter;

//     }

//   } catch (e) {

//     context.commit('setError', error(e));
//     return [];

//   }
// }


// // Add data example

// export async function addSomething(context, payload) {
//   context.commit('setProcessing', true);

//   try {
//     const variables = payload;

//     const result = await apolloClient
//       .mutate({
//         mutation: ADD_SOMETHING,
//         variables,
//         // fetchPolicy: 'network-only'
//       });

//     const { data, errors } = await result;

//     if (errors) {

//       context.commit('setError', error(errors));
//       return null;

//     } else {

//       const newDataSets = [...context.state.SOME_DATA_ARRAY];
//       newDataSets.push(data.addSomething);
//       context.commit('setSomethings', newDataSets);

//       context.commit('setSuccess', addItemSuccess(data.addSomething));
//       return data.addSomething;

//     }

//   } catch (e) {

//     context.commit('setError', error(e));
//     return null;

//   }
// }


// // Update data example

// export async function updateSomething(context, payload) {

//   context.commit('setProcessing', true);

//   try {
//     const variables = payload;

//     const result = await apolloClient
//       .mutate({
//         mutation: UPDATE_SOMETHING,
//         variables,
//         // fetchPolicy: 'network-only'
//       });

//     const { data, errors } = await result;

//     if (errors) {

//       context.commit('setError', error(errors));
//       return null;

//     } else {

//       const index = context.state.SOME_DATA_ARRAY.findIndex(item => item.id === data.updateSomething.id);

//       const newDataSets = [
//         ...context.state.SOME_DATA_ARRAY.slice(0, index),
//         data.updateSomething,
//         ...context.state.SOME_DATA_ARRAY.slice(index + 1)
//       ];

//       context.commit('setSomethings', newDataSets);

//       context.commit('setSuccess', updateItemSuccess(data.updateSomething));
//       return data.updateSomething;

//     }

//   } catch (e) {

//     context.commit('setError', error(e));
//     return null;

//   }
// }


// // Delete data example

// export async function deleteSomething(context, payload) {

//   context.commit('setProcessing', true);

//   try {
//     const variables = payload;

//     const result = await apolloClient
//       .mutate({
//         mutation: DELETE_SOMETHING,
//         variables,
//         // fetchPolicy: 'network-only'
//       });

//     const { data, errors } = await result;

//     if (errors) {

//       context.commit('setError', error(errors));
//       return null;

//     } else {

//       const index = context.state.SOME_DATA_ARRAY.findIndex(item => item.id === data.deleteSomething.id);

//       const newDataSets = [
//         ...context.state.SOME_DATA_ARRAY.slice(0, index),
//         ...context.state.SOME_DATA_ARRAY.slice(index + 1)
//       ];

//       context.commit('setSomethings', newDataSets);

//       context.commit('setVdoSets', vdoSets);
//       context.commit('setSuccess', deleteItemSuccess(data.deleteSomething));
//       return data.deleteSomething;
//     }

//   } catch (e) {

//     context.commit('setError', error(e));
//     return null;

//   }
// }

/* 
 */

export function setLanguage({ commit }, payload) {
  if (process.env.NODE_ENV === "development") {
    console.log("$store/setLanguage", payload); // eslint-disable-line no-console
  }
  commit('changeLanguage', payload)
}

export function initializeData(/* { commit } */) {
  console.log("Initializing Data..."); // eslint-disable-line no-console
  // Initialize All Required Data to Open App
}

export function clearStates(context) {
  context.commit("removeUserState");
  context.commit("removeUserProfile");
  context.commit("Student/removeStudentEnroll");
  context.commit("Student/removeStudentEnrollDetails");
}
